import React, { useState } from 'react'
import { View, StyleSheet, Text, TouchableOpacity } from 'react-native'
import { DropdownComponent } from '../DropdownComponent'
import { AlertMessage } from '../AlertMessage'
import { MONTH, YEARS } from './data'
import { corporateColor } from '../../theme/colors'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'

interface Props {
  getValue: (values: { month: number; year: number }) => void
  initialValue?: { month: number; year: number }
}

export const MonthSelector = ({ getValue, initialValue }: Props) => {
  const { t } = useTranslation()
  const [showPicker, setShowPicker] = useState(false)
  const [selectedData, setSelectedDate] = useState<{ month: number; year: number }>(
    initialValue ?? {
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
    },
  )

  return (
    <>
      <TouchableOpacity
        onPress={() => setShowPicker(true)}
        style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 10 }}
      >
        <Text style={{ fontSize: 14, color: corporateColor, fontWeight: 'bold' }}>
          {t('Selecciona una fecha')}
        </Text>

        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <Text style={{ fontSize: 18, color: corporateColor, fontWeight: 'bold', marginRight: 5 }}>
            {t(MONTH[selectedData.month] ?? '')}
          </Text>
          <Text style={{ fontSize: 18, color: corporateColor, fontWeight: 'bold', marginRight: 5 }}>
            {YEARS[selectedData.year]}
          </Text>
          <FontAwesomeIcon icon={faChevronDown} size={20} color={corporateColor} />
        </View>
      </TouchableOpacity>
      {showPicker && (
        <AlertMessage
          action={() => {
            setShowPicker(false)
            getValue(selectedData)
          }}
          cancelButton
          style={{ marginTop: 0 }}
          actionCancelButton={() => setShowPicker(false)}
        >
          <View style={styles.container}>
            <View style={styles.monthContainer}>
              <DropdownComponent
                data={Object.entries(MONTH).map(([id, name]) => ({ id: +id, name: t(name) }))}
                onChange={(value) =>
                  setSelectedDate((prev) => ({
                    ...prev,
                    month: value,
                  }))
                }
                defaultOption={{ id: new Date().getMonth() + 1, name: '' }}
                customStyles={styles.select}
              />
            </View>
            <View style={styles.yearContainer}>
              <DropdownComponent
                data={Object.entries(YEARS).map(([id, name]) => ({ id: +id, name }))}
                onChange={(value) =>
                  setSelectedDate((prev) => ({
                    ...prev,
                    year: value,
                  }))
                }
                defaultOption={{
                  id: new Date().getFullYear(),
                  name: new Date().getFullYear().toString(),
                }}
                placeholder='Seleccione'
                customStyles={styles.select}
              />
            </View>
          </View>
        </AlertMessage>
      )}
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    marginVertical: 15,
  },
  monthContainer: {
    flex: 1,
    alignItems: 'flex-end',
    marginRight: 20,
  },
  yearContainer: {
    flex: 1,
    alignItems: 'flex-start',
  },
  select: {
    borderWidth: 0,
    borderBottomWidth: 2,
    borderTopWidth: 2,
    width: 120,
    borderRadius: 0,
    padding: 8,
  },
})
